var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPackageDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20H1.326A1.328 1.328 0 010 18.674V6.5A.5.5 0 01.5 6h19a.5.5 0 01.5.5v3a.5.5 0 01-1 0V7H1v11.674c0 .18.146.326.326.326H12.5a.5.5 0 010 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7a.498.498 0 01-.438-.259l-3.02-5.482A.498.498 0 0015.604 1H4.396a.498.498 0 00-.438.259L.938 6.741a.5.5 0 01-.876-.482L3.082.777C3.345.297 3.849 0 4.396 0h11.209c.547 0 1.051.297 1.314.776l3.019 5.482A.499.499 0 0119.5 7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7a.5.5 0 01-.5-.5v-6a.5.5 0 011 0v6a.5.5 0 01-.5.5zM15.5 24a.5.5 0 01-.5-.5v-2c0-3.584 2.916-6.5 6.5-6.5h2a.5.5 0 010 1h-2a5.506 5.506 0 00-5.5 5.5v2a.5.5 0 01-.5.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19a.499.499 0 01-.325-.88l3.057-2.621-3.057-2.621a.5.5 0 01.65-.759l3.5 3a.5.5 0 010 .76l-3.5 3A.497.497 0 0120 19z"
  })));
}

export default SvgPackageDefault;